import { convertISOToMillisecond } from '../../helpers/formatUpdatedDate'
import { decrypt } from '../auth/cryptor'
import { IJobSearch, IFeaturedJobsResponse, IRecommendedData } from '../models'
import {
	IQueryParameters,
	ISpecialJobs,
	Job,
	TCountJob,
	TJobItem
} from './@type'
import { serviceCode, renderUrlParams } from './helper'
import { IMAGE_BASE_URL, JOB_SEARCH_LIMIT, retrieveFields } from './const'
import { ELanguage } from '@microfrontends/react-components'
import { generateJobUrl } from '../../components/SearchJobs/dataSource'
export class JobsSearchApi {
	constructor() { }
	public async jobsSearch(
		params: IQueryParameters,
		language: ELanguage
	): Promise<IJobSearch | null> {
		try {
			const response = await fetch(
				`${process.env.API_DOMAIN
				}/job-search/v1.0/search?t=${Date.now()}`,
				{
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'X-Source': 'Page-Container',
						'Accept-Language': language
					},
					body: JSON.stringify(params)
				}
			)

			if (response.status === 200) {
				const rawData: IJobSearch = await response.json()
				return {
					...rawData,
					data: rawData.data?.map((item) => {
						return {
							...item,
							priorityOrder: convertISOToMillisecond(
								item?.priorityOrder ?? 0
							),
							approvedDate: convertISOToMillisecond(
								item?.approvedOn ?? 0
							),
							expiredDate: convertISOToMillisecond(
								item?.expiredOn ?? 0
							),
							onlineDate: convertISOToMillisecond(
								item?.onlineOn ?? 0
							),
							isTopLevelJob:
								convertISOToMillisecond(
									item?.priorityOrder ?? 0
								) &&
									convertISOToMillisecond(
										item?.priorityOrder ?? 0
									) !== 0
									? true
									: false,
							serviceCode:
								item?.services && item.services.length > 0
									? serviceCode(item)
									: [],
							isPremium: !item.simpleServices
								? false
								: item.simpleServices.includes('isPremium'),
							isHeadhuntJob: !item.simpleServices
								? false
								: item.simpleServices.includes('isHeadhunt'),
							isTopManagementJob: !serviceCode(item)
								? false
								: serviceCode(item).includes('TMJ')
						}
					})
				}
			}
			return null
		} catch (error) {
			console.error(error)
			return null
		}
	}
	public async featureJobs(): Promise<IFeaturedJobsResponse | null> {
		try {
			const response: Response = await fetch(
				`${process.env.FEATURED_JOBS_API_BASE}`,
				{
					headers: {
						'Content-Type': 'application/json'
					}
				}
			)
			if (response.ok && response.status === 200) {
				const data = await response.json()
				return data
			}
			return null
		} catch (error) {
			console.error(error)
			return null
		}
	}
	public async recommendJobs(
		page: number,
		perPage: number,
		userId?: string | number,
		jobId?: string | number,
		utm_source_navi?: string
	): Promise<IRecommendedData | null> {
		let queryString = ""
		queryString = renderUrlParams({
			user: userId,
			jobId,
			limit: 200,
			page: page,
			perPage: perPage
		})

		const url = utm_source_navi === "HighSalary" ? `${process.env.API_DOMAIN}/smartnavi/v7/jobs${queryString}` : `${process.env.API_DOMAIN}/smartnavi/v5/jobs${queryString}`

		try {
			const response = await fetch(
				url,
				{
					headers: {
						'Content-Type': 'application/json'
					}
				}
			)
			if (response.ok && response.status === 200) {
				const data = await response.json()
				return data
			}
			return null
		} catch (error) {
			console.error(error)
			return null
		}
	}


	public async specialJobs(
		jobId: number[],
		token: string
	): Promise<ISpecialJobs[] | null> {
		const decryptToken = decrypt(token)
		try {
			const response = await fetch(
				`${process.env.API_DOMAIN}/api-gateway/v1.0/special-jobs`,
				{
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${decryptToken}`
					},
					body: JSON.stringify({ jobId })
				}
			)
			if (response.status === 200) {
				const dataRespone = await response.json()
				return dataRespone.data
			}
			return null
		} catch (error) {
			console.error(error)
			return null
		}
	}
	public async updateBookmarkJobsById(
		jobId: number,
		isSaved: boolean,
		token: string
	): Promise<{
		type: string
		id: number
	} | null> {
		const decryptToken = decrypt(token)
		try {
			const response = await fetch(
				`${process.env.API_DOMAIN}/api-gateway/v1.0/${isSaved ? 'unsave-job' : 'save-job'
				}`,
				{
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${decryptToken}`
					},
					body: JSON.stringify({ jobId })
				}
			)
			if (response.status === 200) {
				const dataRespone = await response.json()
				return dataRespone.data
			}
			return null
		} catch (error) {
			console.error(error)
			return null
		}
	}

	public async headhunterJobsList(
		language: string,
		userId?: number
	): Promise<TJobItem[] | []> {
		try {
			const response = await fetch(
				`${process.env.API_DOMAIN
				}/job-search/v1.0/top-company-jobs?t=${Date.now()}`,
				{
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						Accept: 'application/json',
						'Accept-Language': language
					},
					body: JSON.stringify({
						hitsPerPage: JOB_SEARCH_LIMIT,
						retrieveFields: retrieveFields,
						userId
					})
				}
			)
			if (response.status != 200) {
				throw new Error('Request error')
			}
			const jsonData = await response.json()

			if (jsonData && jsonData.data) {
				const data: Job[] = jsonData.data
				return data.map((item) => {
					return {
						title: item.jobTitle,
						company: item.isAnonymous
							? "Vietnamworks' Client"
							: item.companyName,
						companyId: item.companyId,
						workingLocations: item.workingLocations,
						logo: item.companyLogo,
						jobLevelId: item.jobLevelId,
						url: item.jobUrl
							? item.jobUrl
							: generateJobUrl(
								item.alias,
								item.jobId,
								language,
								''
							),
						isAnonymous: !!item.isAnonymous,
						jobDescription: item.jobDescription,
						jobRequirement: item.jobRequirement,
						salary: item.prettySalary,
						address: item.address,
						alias: item.alias,
						jobId: item.jobId
					}
				})
			}
		} catch (err) {
			console.log(err)
			return []
		}
		return []
	}

	public async getTotalJobs(field: string): Promise<TCountJob[] | []> {
		try {
			const response = await fetch(
				`${process.env.API_DOMAIN}/job-search/v1.0/count`,
				{
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						Accept: 'application/json'
					},
					body: JSON.stringify({
						aggs: { field: field }
					})
				}
			)
			if (response.status != 200) {
				throw new Error('Request error')
			}
			const jsonData = await response.json()
			if (jsonData && jsonData.data) {
				return jsonData.data
			}
			return []
		} catch (error) {
			console.error(error)
			return []
		}
	}

	public async getTotalJobsOnline(): Promise<number> {
		try {
			const response = await fetch(
				`${process.env.API_DOMAIN}/job-search/v1.0/search`,
				{
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						Accept: 'application/json'
					},
					body: JSON.stringify({
						hitsPerPage: 1,
						retrieveFields: ['jobId']
					})
				}
			)
			if (response.status != 200) {
				throw new Error('Request error')
			}
			const jsonData = await response.json()
			if (jsonData?.meta && jsonData?.meta?.nbHits) {
				return jsonData.meta.nbHits
			}
			return 0
		} catch (error) {
			console.error(error)
			return 0
		}
	}

	public async searchJobByCategories(
		language: ELanguage,
		body: string | null = null
	): Promise<TJobItem[] | []> {
		try {
			const response = await fetch(
				`${process.env.API_DOMAIN
				}/job-search/v1.0/search?t=${Date.now()}`,
				{
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						Accept: 'application/json',
						'Accept-Language': language
					},
					body: body
				}
			)
			if (response.status != 200) {
				throw new Error('Request error')
			}
			const jsonData = await response.json()
			if (!!jsonData) {
				return jsonData.data.map((item) => {
					return {
						title: item.jobTitle,
						company: item.isAnonymous
							? "Vietnamworks' Client"
							: item.companyName,
						companyId: item.companyId,
						workingLocations: item.workingLocations,
						logo: item.companyLogo,
						url: item.url
							? item.url
							: generateJobUrl(
								item.alias,
								item.jobId,
								language,
								''
							),
						jobLevel:
							language === ELanguage.EN
								? item.jobLevel
								: item.jobLevelVI,
						jobLevelId: item.jobLevelId,
						isAnonymous: !!item.isAnonymous,
						jobDescription: item.jobDescription,
						jobRequirement: item.jobRequirement,
						salary: item.prettySalary,
						address: item.address,
						jobId: item.jobId,
						alias: item.alias
					}
				})
			}
			return []
		} catch (err) {
			return []
		}
	}
}
export default new JobsSearchApi()
